import React from 'react';

/**
 * Error state component for signage
 * @param {Object} props - Component props
 * @param {React.RefObject} props.containerRef - Container reference
 * @param {string} props.error - Error message
 * @param {string} props.screenId - Screen ID
 * @param {string} props.orientation - Screen orientation
 * @returns {JSX.Element} Error state component
 */
const ErrorState = ({ containerRef, error, screenId, orientation }) => (
  <div className='signage row panels panels-horizontal' style={{ margin: "0px" }}>
    <div ref={containerRef} style={{ 
      height: "100vh", 
      width: "100%", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center" 
    }}>
      <div style={{ 
        color: '#dc3545', 
        textAlign: 'center',
        padding: "24px",
        border: "2px solid #dc3545",
        borderRadius: "8px",
        backgroundColor: "#f8d7da"
      }}>
        <h3 style={{ margin: "0 0 12px 0" }}>Error Loading Signage</h3>
        <p style={{ margin: "0 0 16px 0" }}>{error}</p>
        <div style={{ fontSize: "14px", color: "#721c24" }}>
          Screen ID: {screenId} | Orientation: {orientation}
        </div>
      </div>
    </div>
  </div>
);

export default ErrorState;
